export interface IUserDetail {
  amount_due: number;
  appVersion: string;
  autoGenNumber: boolean;
  banned: boolean;
  deviceCarrier: string;
  deviceModel: string;
  deviceOS: string;
  deviceOSVersion: string;
  emailAddress: string;
  fullName: string;
  has_membership: boolean;
  id: string;
  joined: string;
  phone: string;
  removed: boolean;
  status: string;
  acceptedTOSOn: string;
  hidden: boolean;
  // Wallet balance (cents) from the user's first GraphQL userWallet
  walletBalance: number;
  // Whether the user has any wallet on file
  hasWallet: boolean;
}

export enum UserDetailStatus {
  'BLACKLISTED' = 'blacklisted',
  'ACTIVE' = 'active',
  'INACTIVE' = 'inactive',
}

export interface IUserOrganizationDetails extends IUserDetail {
  organization: string;
  role: string;
  systems: ISystemOrganization[];
  status: string;
}

export interface ISystemOrganization {
  id: string;
  name: string;
  old_id: string;
  role?: string;
}
